import { useScrapeStore } from '../store/scrapeStore';

/* Local Ollama proxy gateway — the embedding engine. OpenAI-compatible
   /v1/embeddings endpoint exposed by Ollama at localhost:11434. */
export async function embedText(text, model) {
    const { ollamaBase, embedModel } = useScrapeStore.getState();
    const m = model || embedModel;
    const res = await fetch(`${ollamaBase.replace(/\/$/, '')}/v1/embeddings`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ model: m, input: text }),
    });
    if (!res.ok) throw new Error(`Ollama embed failed (HTTP ${res.status}) — is the proxy gateway running?`);
    const data = await res.json();
    const vec = data.data?.[0]?.embedding;
    if (!Array.isArray(vec) || vec.length < 1) throw new Error('Ollama returned no embedding.');
    return vec;
}

/* Test the local gateway is reachable. */
export async function pingOllama() {
    const { ollamaBase } = useScrapeStore.getState();
    try {
        const res = await fetch(`${ollamaBase.replace(/\/$/, '')}/api/tags`);
        return res.ok;
    } catch {
        return false;
    }
}

/* Deterministic, overlap-aware chunking so long scraped pages become several
   self-contained vectors instead of one diluted embedding. */
export function chunkText(text, size = 512, overlap = 48) {
    const clean = String(text || '').replace(/\s+/g, ' ').trim();
    if (!clean) return [];
    if (clean.length <= size) return [clean];
    const out = [];
    let i = 0;
    while (i < clean.length) {
        let end = Math.min(i + size, clean.length);
        // prefer chunk boundaries at sentence/space ends
        if (end < clean.length) {
            const spaceAt = clean.lastIndexOf(' ', end);
            if (spaceAt > i + size / 2) end = spaceAt;
        }
        out.push(clean.slice(i, end).trim());
        if (end <= i) break;
        i = end - overlap;
    }
    return out.filter(Boolean);
}